import { render } from "./FormSelectRelOne.vue?vue&type=template&id=3d4c1416"
import script from "./FormSelectRelOne.vue?vue&type=script&lang=js"
export * from "./FormSelectRelOne.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/FormCustom/FormSelectRelOne.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d4c1416"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d4c1416', __exports__)) {
    console.log('reload')
    api.reload('3d4c1416', __exports__)
  }
  
  module.hot.accept("./FormSelectRelOne.vue?vue&type=template&id=3d4c1416", () => {
    console.log('re-render')
    api.rerender('3d4c1416', render)
  })

}


export default __exports__